import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

import {
  IAPI_BUS007_Request,
  IAPI_BUS007_Response,
  IAPI_FAC043_Request,
  IAPI_FAC043_Response,
} from "../../../type/apiType";

// 廃止済み施設職員有無および未提出申請有無チェック
// API仕様書_掛金
const httpAPI_BUS007 = async (
  param: IAPI_BUS007_Request
): Promise<IAPI_BUS007_Response> => {
  let res = await http.post(ApiUrl.API_BUS007, {
    ...param,
  });
  return res.data;
};
// 特定職員数の見込数クリアAPI
// API仕様書_施設
const httpAPI_FAC043 = async (
  param: IAPI_FAC043_Request
): Promise<IAPI_FAC043_Response> => {
  let res = await http.post(ApiUrl.API_FAC043, {
    ...param,
  });
  return res.data;
};

export { httpAPI_BUS007, httpAPI_FAC043 };
